import React from "react";
import SearchEvents from "../events/SearchEvents";

export default function DashboardCoachSearchBar({ onSearch }) {
  return (
    <div className="mb-0 w-full relative">
      <SearchEvents onSearch={onSearch} placeholder="Search Coaches" />
    </div>
  );
}
